import { memo } from 'react';

type PDFViewerProps = {
  title: string;
  pdfUrl: string;
};

export const PDFViewer = memo(({ title, pdfUrl }: PDFViewerProps) => {
  return (
    <iframe
      src={`${pdfUrl}#toolbar=0`}
      width="100%"
      height={window.innerHeight - 152}
      title={title}
    />
  );
});
